import {
	API_ADMIN_PATCH_SERVIPAY_TERMINAL,
	API_ADMIN_POST_SERVIPAY_TERMINAL,
	API_ADMIN_DELETE_SERVIPAY_TERMINAL,
	API_ADMIN_GET_ALL_SERVIPAY_TERMINAL,
	API_ADMIN_GET_SERVIPAY_TERMINAL,
	ADMIN_INIT_NEW_SERVIPAY_TERMINAL,
	ADMIN_RESET_FOCUS_SERVIPAY_TERMINAL,
} from 'actions/servipayTerminal';

export function adminGetAllServipayTerminal() {
	return {
		type: API_ADMIN_GET_ALL_SERVIPAY_TERMINAL,
		payload: {
			request: {
				url: `/admin/servipayTerminals`,
			},
		},
	};
}

export function adminGetServipayTerminalById(terminalId) {
	return {
		type: API_ADMIN_GET_SERVIPAY_TERMINAL,
		payload: {
			request: {
				url: `/admin/servipayTerminals/${terminalId}`,
			},
		},
	};
}

export function adminPatchServipayTerminal(terminal) {
	return {
		type: API_ADMIN_PATCH_SERVIPAY_TERMINAL,
		payload: {
			request: {
				url: `/admin/servipayTerminals/${terminal.id}`,
				method: 'PATCH',
				data: terminal,
			},
		},
	};
}

export function adminPostServipayTerminal(terminal) {
	return {
		type: API_ADMIN_POST_SERVIPAY_TERMINAL,
		payload: {
			request: {
				url: `/admin/servipayTerminals`,
				method: 'POST',
				data: terminal,
			},
		},
	};
}

export function adminDeleteServipayTerminal(terminalId) {
	return {
		type: API_ADMIN_DELETE_SERVIPAY_TERMINAL,
		payload: {
			request: {
				url: `/admin/servipayTerminals/${terminalId}`,
				method: 'delete',
			},
		},
	};
}

export function initNewServipayTerminal() {
	return {
		type: ADMIN_INIT_NEW_SERVIPAY_TERMINAL,
	};
}

export function resetFocusServipayTerminal() {
	return {
		type: ADMIN_RESET_FOCUS_SERVIPAY_TERMINAL,
	};
}
